import { computed, Injectable, signal } from '@angular/core';

import type { ModalComponent } from '@components/atoms/modal/modal.component';

type ModalOptions = {
	force?: boolean;
};

@Injectable()
export class ModalService {
	private activeModal = signal<ModalComponent | null>(null);

	isActive = computed(() => this.activeModal() !== null);
	isClosable = computed(() => this.activeModal()?.closable() ?? true);
	activeModalName = computed(() => this.activeModal()?.name());

	getActiveModal(): ModalComponent | null {
		return this.activeModal();
	}

	open(modalInstance: ModalComponent, options: ModalOptions = {}): void {
		if (this.activeModal() && !options.force) return;

		if (this.activeModal() && options.force) {
			this.close();
		}

		this.activeModal.set(modalInstance);
	}

	notifyClose(): void {
		this.activeModal()?.close.emit();
	}

	close(): void {
		// if (!this.isClosable()) return;

		this.activeModal.set(null);
	}
}
